module.exports = __webpack_public_path__ + "img/fusion-reactor-equipment.effab340.png";